import React, { useEffect, useRef } from "react";
import MessageList from "./MessageList";
import { useLocation } from "react-router-dom";

const FloatingButton = ({ isMessageListOpen, setIsMessageListOpen }) => {
  // Get current route location
  const location = useLocation();
  const shouldAddBottomMargin = location.pathname === "/messenger";

  const floatingButtonRef = useRef(null);

  const handleButtonClick = () => {
    setIsMessageListOpen(!isMessageListOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        floatingButtonRef.current &&
        !floatingButtonRef.current.contains(event.target)
      ) {
        setIsMessageListOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={floatingButtonRef} style={{ zIndex: 50 }}>
      <button
        className={`ticket-button ${shouldAddBottomMargin ? "mb-12" : ""}`}
        onClick={handleButtonClick}
      >
        <i className="bi bi-chat-right-dots-fill"></i>
      </button>
      {isMessageListOpen && (
        <MessageList setIsMessageListOpen={setIsMessageListOpen} />
      )}
    </div>
  );
};

export default FloatingButton;
